<template>
  <div>
    <div :class="'title-box-' + item" v-for="(item, index) in 4" :key="index">
      <div class="icon-box">
        <div class="icon"></div>
      </div>
      <div class="content-box">
        <div class="title-box">{{ titleList[index] }}</div>
        <div class="number-box">{{ numberInfo[numberList[index]] }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "moduleNumber",
  props: {
    numberInfo: {
      type: Object
    }
  },
  data() {
    return {
      titleList: [
        "学院数量",
        "区域内风险点",
        "区域内隐患点",
        "区域内视频报警总数"
      ],
      numberList: [
        "totalDepartments",
        "totalRisk",
        "totalHiddenDangers",
        "totalMonitoring"
      ]
    };
  },
  mounted() {},
  methods: {}
};
</script>
<style scoped lang="scss">
.title-box-1 {
  width: 180px;
  height: 70px;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 240px;
  left: 710px;
}
.title-box-2 {
  width: 180px;
  height: 70px;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 115px;
  left: 970px;
}
.title-box-3 {
  width: 180px;
  height: 70px;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 120px;
  left: 1360px;
}
.title-box-4 {
  width: 180px;
  height: 70px;
  display: flex;
  flex-direction: row;
  position: absolute;
  top: 330px;
  left: 1180px;
}
.icon-box {
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  .icon {
    background: url("~@/assets/img/bigDataCollge/number-icon.png") center center no-repeat;
    background-size: 100% 100%;
    width: 20px;
    height: 20px;
    border-radius: 8px;
  }
}
.content-box {
  margin-left: 10px;
  width: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .title-box {
    width: 150px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(219, 225, 255, 1);
    height: 25px;
    line-height: 25px;
  }
  .number-box {
    width: 116px;
    margin-top: 4px;
    padding-left: 10px;
    height: 30px;
    color: rgba(255, 252, 153, 1);
    font-size: 18px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 30px;
    background: url("~@/assets/img/bigDataCollge/module-number-bg.png") center center no-repeat;
    background-size: 100% 100%;
  }
}
</style>
